import { createContext } from 'react';
export const MainNavigationContext = createContext({
    distanceBetweenPrimaryNavigationItemsInRem: 0,
    isLoggedIn: false,
    isMobileMenuOpen: false,
    isNestedNavigationOpen: false,
    registerNavigationItem: element => undefined,
    setIsNestedNavigationOpen: () => undefined,
    setShouldFocusNestedNavigation: () => undefined,
    shouldFocusNestedNavigation: false,
    unregisterNavigationItem: element => undefined,
    updateActiveNavigationItem: (element, isActive) => undefined,
});
